import UserLockedOut from './UserLockedOut';

export default UserLockedOut;
